import ExpandedInventorySummaryComponent from './ExpandedInventorySummary';

const ExpandedInventorySummary = ExpandedInventorySummaryComponent;

export default ExpandedInventorySummary;
